import { AxiosResponse } from 'axios';
import api from '../../../services/api';
import {
  CustomerIntelligenceFilters,
  CustomerIntelligenceSort,
  CustomerIntelligenceChartResponse,
  CustomerIntelligenceResponse,
  CustomerReportType,
} from '../types';

function toDateOnly(value: Date): string {
  const year = value.getFullYear();
  const month = `0${value.getMonth() + 1}`.slice(-2);
  const day = `0${value.getDate()}`.slice(-2);
  return `${year}-${month}-${day}`;
}

export async function getCustomerIntelligenceReport(
  reportType: CustomerReportType,
  filters: CustomerIntelligenceFilters,
  page: number,
  pageSize: number,
  sort?: CustomerIntelligenceSort,
): Promise<CustomerIntelligenceResponse> {
  const params: Record<string, string | number> = {
    startDate: filters.startDate,
    endDate: filters.endDate,
    page,
    pageSize,
  };

  if (reportType === 'abc-curve' || reportType === 'at-risk') {
    if (filters.curve) params.curve = filters.curve;
  }

  if (reportType === 'at-risk') {
    if (filters.risk) params.risk = filters.risk;
    if (filters.daysWithoutPurchase !== undefined) {
      params.daysWithoutPurchase = filters.daysWithoutPurchase;
    }
  }

  if (sort) {
    params.sortBy = sort.sortBy;
    params.sortDirection = sort.sortDirection;
  }

  const response = await api.get<CustomerIntelligenceResponse>(
    `/dashboard/details/customer-intelligence/${reportType}`,
    {
      params,
    },
  );

  return response.data;
}

export async function getCustomerIntelligenceChart(
  reportType: CustomerReportType,
  filters: CustomerIntelligenceFilters,
): Promise<CustomerIntelligenceChartResponse> {
  const params: Record<string, string | number> = {
    startDate: filters.startDate,
    endDate: filters.endDate,
  };

  if (reportType === 'abc-curve' || reportType === 'at-risk') {
    if (filters.curve) params.curve = filters.curve;
  }

  if (reportType === 'at-risk') {
    if (filters.risk) params.risk = filters.risk;
    if (filters.daysWithoutPurchase !== undefined) {
      params.daysWithoutPurchase = filters.daysWithoutPurchase;
    }
  }

  const response = await api.get<CustomerIntelligenceChartResponse>(
    `/dashboard/details/customer-intelligence/${reportType}/chart`,
    { params },
  );

  return response.data;
}

export async function exportCustomerIntelligenceReport(
  reportType: CustomerReportType,
  filters: CustomerIntelligenceFilters,
  sort?: CustomerIntelligenceSort,
): Promise<AxiosResponse<Blob>> {
  const params: Record<string, string | number> = {
    startDate: filters.startDate,
    endDate: filters.endDate,
  };

  if (reportType === 'abc-curve' || reportType === 'at-risk') {
    if (filters.curve) params.curve = filters.curve;
  }

  if (reportType === 'at-risk') {
    if (filters.risk) params.risk = filters.risk;
    if (filters.daysWithoutPurchase !== undefined) {
      params.daysWithoutPurchase = filters.daysWithoutPurchase;
    }
  }

  if (sort) {
    params.sortBy = sort.sortBy;
    params.sortDirection = sort.sortDirection;
  }

  return api.get<Blob>(
    `/dashboard/details/customer-intelligence/${reportType}/export`,
    { params, responseType: 'blob' },
  );
}

export { toDateOnly };
